export default __webpack_public_path__ + "static/media/5_1_3.5782a444.png";